import { DataSyncResponse, NavigationDataResponse } from '@/api/navigationApi/types.gen'

export enum NavigationState {
  CheckingSync = 'CheckingSync',
  SyncInProgress = 'syncInProgress',
  SyncFinished = 'SyncFinished',
  Monitoring = 'Monitoring',
}

export enum RouteModuleState {
  Initializing = 'Initializing',
  Pausing = 'Pausing',
  Resuming = 'Resuming',
  FetchingDrivers = 'FetchingDrivers',
  Starting = 'Starting',
  NoScheduledDrive = 'NoScheduledDrive',
  Fetching = 'Fetching',
  Fetched = 'Fetched',
  Driving = 'Driving',
  Paused = 'Paused',
  Finished = 'Finished',
  Maintenance = 'Maintenance',
  CommunicationError = 'CommunicationError',
  NoDriverSelected = 'NoDriverSelected',
  Skipping = 'Skipping',
  Finishing = 'Finishing',
  Freeride = 'Freeride',
}

export enum Actions {
  NotifyError = 'notifyError',
  NotifySuccess = 'notifySuccess',
}

export type Events =
  | { type: 'SYNC_UPDATE'; status: DataSyncResponse['status']; updatedAt: number }
  | { type: 'SYNC_ERROR'; error?: Error | null }
  | { type: 'NAV_UPDATE'; data: NavigationDataResponse; shouldStartDropoff: boolean; secondsToDropoff: number }
  | { type: 'NAV_ERROR'; error?: Error | null }
  | { type: 'REQUEST_PAUSE' }
  | { type: 'REQUEST_RESUME' }
  | { type: 'REQUEST_START' }
  | { type: 'CLEAR_ERROR' }
  | { type: 'REQUEST_SKIP' }
  | { type: 'REQUEST_FINISH' }
  | { type: 'RESET' }
